<ol class="stepper" aria-label="First sync steps">
  <ng-container *ngFor="let label of labels; let i = index; let last = last">
    <li class="st" [class.done]="isDone(i)" [class.now]="i === current" [attr.aria-current]="i === current ? 'step' : null">
      <span class="dot">
        <i class="bi bi-check-lg" *ngIf="isDone(i)"></i>
        <ng-container *ngIf="!isDone(i)">{{ i + 1 }}</ng-container>
      </span>
      <span class="lbl">{{ label }}</span>
    </li>
    <li class="ln" [class.done]="isDone(i)" *ngIf="!last" aria-hidden="true"></li>
  </ng-container>
</ol>

<div class="mstep">
  <div class="mstep-row">
    <strong>Step {{ current + 1 }} of {{ labels.length }}</strong>
    <span class="mstep-name">{{ labels[current] }}</span>
  </div>
  <div class="progress-track">
    <div class="progress-fill" [style.width.%]="percent"></div>
  </div>
</div>
